import Head from 'next/head';

import user from '../src/services/api/user';

import Home from '../src/components/Home';
import SupportForm from '../src/components/common/elements/SupportForm';

import landing from '../public/static/data/landing.json';
const Index = ({ profile }) => (
  <>
    <Head>
      <title key="title">YUPWEGO</title>
      <meta key="og:type" content="website" property="og:type" />
      <meta key="description" content={landing.banner.description} />
    </Head>
    <Home profile={profile} landing={landing} />
    <SupportForm />
  </>
);

Index.getInitialProps = async ({ req, res }) => {
  const profile = await user.profile(req, res);
  return {
    profile
  };
};

export default Index;
